import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { Publicacion, Boletines, Const, Static } from '@app/shared';
import { TreeviewItem } from 'ngx-treeview';
import { Tree } from '@angular/router/src/utils/tree';
import { C, e } from '@angular/core/src/render3';

@Injectable()
export class PublicationsPageDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }




  /**
   * Metodo que devuelve todoss las publicaciones por boletin
   *
   * @param {number} id
   * @return {*}  {Observable<Publicacion[]>}
   * @memberof PublicationsPageDataService
   */
  getPublicaciones(id: number): Observable<Publicacion[]> {
    return new Observable(obs => {
      // this.http.skipErrorHandler().get<Publicacion[]>(this.api.get('adminPublication', [id])).subscribe(
        this.http.skipErrorHandler().get<Publicacion[]>(this.api.get('externalPublication',[id])).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


  /**
   * Metodo que obtiene todos los boletines
   *
   * @return {*}  {Observable<Boletines[]>}
   * @memberof PublicationsPageDataService
   */
  getBulletins(): Observable<any[]> {
    return new Observable(obs => {
      // this.http.skipErrorHandler().get<Publicacion[]>(this.api.get('adminBulletin', [id])).subscribe(
      this.http.skipErrorHandler().get<any[]>(this.api.get('externalBulletin')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


  /**
   * procesa los boletines y devuelve un tree con la informacion
   *
   * @return {*}  {TreeviewItem[]}
   * @memberof PublicationsPageDataService
   */
  getProcessBolletins(): TreeviewItem[] {
    let child: TreeviewItem[] = [];
    let tree: TreeviewItem[] = [];
    this.getBulletins().subscribe(res => {
      res.sort((a, b) => a.year - b.year);
      res.forEach(p => {
        p.boletines.forEach((c: any) => {
            this.txtMonths(c);
            child.push(new TreeviewItem({
              text: `${c.codigo} - ${c.mes_letras} - ${c.ano}`,
              value: c.id
            }));
        });
        tree.push(new TreeviewItem({
          value: p.year,
          text: `${p.year}`,
          children: Static.copyObjet(child),
          collapsed: true
        }));
        child = [];
      });
    });
    return tree;
  }


  /**
   * Metodo que trasforma el numero del me a nombre del mes
   *
   * @param {Boletines} buletin
   * @memberof PublicationsPageDataService
   */
  txtMonths(buletin: Boletines) {
    switch (buletin.mes) {
      case 1:
        buletin.mes_letras = 'Enero';
        break;
      case 2:
        buletin.mes_letras = 'Febrero';
        break;
      case 3:
        buletin.mes_letras = 'Marzo';
        break;
      case 4:
        buletin.mes_letras = 'Abril';
        break;
      case 5:
        buletin.mes_letras = 'Mayo';
        break;
      case 6:
        buletin.mes_letras = 'Junio';
        break;
      case 7:
        buletin.mes_letras = 'Julio';
        break;
      case 8:
        buletin.mes_letras = 'Agosto';
        break;
      case 9:
        buletin.mes_letras = 'Septiembre';
        break;
      case 10:
        buletin.mes_letras = 'Octubre';
        break;
      case 11:
        buletin.mes_letras = 'Noviembre';
        break;
      case 12:
        buletin.mes_letras = 'Diciembre';
        break;
    }
  }


  /**
   * Servicio para descargar los documentos publicados
   *
   * @param {number} pk
   * @return {*}  {Observable<any>}
   * @memberof PublicationsPageDataService
   */
  dowloadFilePublicaction(pk: number): Observable<any> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
        .get(this.api.get('downloadDocumentPublication', [pk]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              if (err.status === 500) {
                this.toastr.error('No se pudo realizar la petición al servidor.', 'Ocurrió un error');
              } else {
                this.toastr.error(err.error['message'], 'Fallo de descarga');
              }
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/publications-page/shared/publications-page.data.service.ts